import type { IProduct, ProductChannel } from '@wegic/price-ui';
import { isOnline } from '@/const/env';

export const TRIAL_PAY_PRODUCT: IProduct = isOnline
  ? {
      id: '1952649842822004739',
      name: 'Platform',
      pricingType: 'free',
      trProductId: '1952649842822004739',
      productKey: '',
      count: 200,
      channel: 'Stripe' as ProductChannel,
      prices: [
        {
          id: '1952649842851364866',
          originalAmount: 0,
          amount: 0,
          discount: '0',
          currency: '',
          billInterval: null,
          billIntervalCount: null,
          productId: '1001',
          trPriceId: '',
          channel: 'Stripe' as ProductChannel,
          levelName: 'Free',
        },
      ],
    }
  : {
      id: '1952284193945460738',
      name: 'Platform',
      pricingType: 'free',
      trProductId: '1952284193945460738',
      productKey: '',
      count: 200,
      channel: 'Stripe' as ProductChannel,
      prices: [
        {
          id: '1952284194071289858',
          originalAmount: 0,
          amount: 0,
          discount: '0',
          currency: '',
          billInterval: null,
          billIntervalCount: null,
          productId: '1001',
          trPriceId: '',
          channel: 'Stripe' as ProductChannel,
          levelName: 'Free',
        },
      ],
    };
